import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { CalendarDaysIcon, HeadphonesIcon, ListChecksIcon, SparklesIcon, TimerIcon, TrophyIcon } from 'lucide-react';
const benefits = [[TimerIcon, 'Save time', 'Plan stronger classes in minutes, not hours.'], [ListChecksIcon, 'Ready-to-teach', 'Use clear structures from warm-up to cool-down.'], [HeadphonesIcon, 'Choreography support', 'Keep every class fresh, musical, and energetic.'], [CalendarDaysIcon, 'Annual planning', 'Organize a full year with less stress.'], [SparklesIcon, 'Themed sessions', 'Create memorable moments that students share.'], [TrophyIcon, 'Instructor success', 'Teach with clarity, confidence, and momentum.']];
export function SolutionReveal() {
  return <section className="bg-white px-4 py-20 sm:py-24" data-id="element-196">
      <div className="mx-auto max-w-6xl" data-id="element-197">
        <header className="mx-auto max-w-3xl text-center" data-id="element-198">
          <p className="headline-kicker text-xs font-bold text-violet" data-id="element-199">
            THE COMPLETE SYSTEM
          </p>
          <h2 className="mt-3 font-display text-3xl font-black uppercase text-navy sm:text-5xl" data-id="element-200">
            A complete teaching system{' '}
            <span className="text-violet" data-id="element-201">built for real instructors.</span>
          </h2>
          <p className="mt-4 text-slate-600" data-id="element-202">
            More than routines: a structured way to teach dynamic, professional
            dance fitness classes from the first beat to the final cooldown.
          </p>
        </header>
        <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-203">
          {benefits.map(([Icon, title, body], index) => {
          const BenefitIcon = Icon as typeof TimerIcon;
          return <motion.article key={title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.05
          }} className="rounded-2xl border border-line bg-white p-6 shadow-sm" data-id="element-204">
                <span className="flex size-11 items-center justify-center rounded-xl bg-violet-mist text-violet" data-id="element-205">
                  <BenefitIcon size={22} data-id="element-206" />
                </span>
                <h3 className="mt-4 font-display text-lg font-extrabold uppercase text-navy" data-id="element-207">
                  {title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-600" data-id="element-208">
                  {body}
                </p>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}